export default __webpack_public_path__ + "static/media/DSC_0514.bca45285.jpg";